<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-13 11:39:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 11:40:39
 * @FilePath: /chaoyongtuan/src/views/sampleOrder/importLog/tableCells/statusCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="tag loading-tag" :class="['loading-tag', 'success-tag', 'error-tag', 'error-tag'][row.task_status]">{{ taskStatus(row) }}</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {},
	methods: {
		taskStatus(row) {
			const taskStatusMap = new Map([
				[0, '上传中'],
				[1, '上传成功'],
				[2, '上传失败'],
				[3, '上传中'],
			]);
			return +row.task_status === 3 && +row.fail_count > 0 ? '部分失败' : taskStatusMap.get(+row.task_status);
		},
	},
	components: {},
};
</script>
<style lang="less" scoped>
.tag {
	display: flex;
	align-items: center;
	&::before {
		content: '';
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 8px;
	}
	&.error-tag::before {
		background-color: @color-r;
	}
	&.loading-tag::before {
		background-color: @color-o;
	}
	&.success-tag::before {
		background-color: @color-g;
	}
}
</style>
